import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/blocks/QuizContestBlock/Content.tsx");
